<template>
  <v-app class="white">
    <v-toolbar class="white elevation-1" fixed app>
      <v-toolbar-side-icon color="primary-text" @click="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <router-link to="/" class="mainLink">
        <img src="/static/logo.png" srcset="/static/logo@2x.png 2x" />
      </router-link>
      <div class="pl-5 light-navy menu-text hidden-sm-and-down">
        <span class="book">tel:</span> <span class="strong">775 909 117</span>
      </div>
      <div class="pl-4 primary-text menu-text hidden-sm-and-down">
        <span class="book">email:</span> <span class="strong">hello@sifty.eu</span>
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down regular">
        <v-btn flat @click="scrollTo(item.selector)" class="menu-text primary-text" v-for="item in menuLinks" :key="item.id">{{ item.text }}</v-btn>
        <v-btn flat href="https://shop.sifty.eu/" target="_blank" class="menu-text-button hospital-green white--text strong">
          <span class="px-4">Koupit diář</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer
            v-model="drawer"
            temporary
            fixed
    >
      <v-list class="pa-1 regular">
        <v-list-tile v-for="item in menuLinks" :key="item.id" @click="scrollTo(item.selector)">
          <v-list-tile-content>
            <v-list-tile-title>{{ item.text }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-btn flat href="https://shop.sifty.eu/" target="_blank" block class="menu-text-button hospital-green white--text strong">
        <span class="px-4">Koupit diář</span>
      </v-btn>
    </v-navigation-drawer>
    <v-content>
      <router-view />
    </v-content>
    <footer class="text-xs-center white pt-5 pb-5" id="partners">
      <h3 class="light-navy book font-48">Partneři</h3>
      <short-line />
      <p class="regular menu-text light-grey pt-3">Děkujeme našim partnerům</p>
      <div class="py-5 px-2">
        <v-container>
        <v-layout row wrap align-center justify-center fill-height>
            <v-flex xs6 sm3 v-for="logo in logos" :key="logo.id">
                <a :href="logo.url" target="_blank">
                    <img :src="logo.image" style="max-width: 100%" :srcset="!!logo.retina ? logo.retina + ' 2x' : false" />
                </a>
                <v-flex xs12 class="pb-4"></v-flex>
            </v-flex>
        </v-layout>
        </v-container>
      </div>
    </footer>
    <footer class="accent">
        <v-container>
            <div class="text-xs-center">
              <a href="https://www.facebook.com/sifty.eu/" class="pr-1 no-decoration" target="_blank">
                <v-icon>mdi-facebook</v-icon>
              </a>
              <a href="https://www.instagram.com/sifty.eu/" class="pr-1 no-decoration" target="_blank">
                <v-icon>mdi-instagram</v-icon>
              </a>
              <a href="https://www.linkedin.com/company/sifty/" class="pr-1 no-decoration" target="_blank">
                <v-icon>mdi-linkedin</v-icon>
              </a>
              <a href="https://twitter.com/sifty_eu" class="no-decoration" target="_blank">
                <v-icon>mdi-twitter</v-icon>
              </a>
            </div>
        </v-container>
    </footer>
  </v-app>
</template>

<script>
    import ShortLine from './components/ShortLine'
    export default {
        components: {
            ShortLine
        },
        computed: {
            options () {
                return {
                    offset: -50
                }
            }
        },
        data () {
            return {
                drawer: false,
                menuLinks: [
                    {
                        id: 1,
                        text: 'Výzva týdne',
                        selector: 'challengeOfTheWeek'
                    },
                    {
                        id: 2,
                        text: 'Vyzyvatelé',
                        selector: 'challengers'
                    },
                    {
                        id: 3,
                        text: 'Ambasadoři',
                        selector: 'ambasadors'
                    },
                    {
                        id: 4,
                        text: 'Partneři',
                        selector: 'partners'
                    }
                ],
              logos: [
                {
                  id: 1,
                  image: '/static/logo_fond.png',
                  retina: '/static/logo_fond@2x.png',
                  url: 'https://www.stkprochlapy.cz/'
                },
                {
                  id: 2,
                  image: '/static/logo-nevypust.png',
                  retina: '/static/logo-nevypust@2x.png',
                  url: 'http://nevypustdusi.cz'
                },
                {
                  id: 3,
                  image: '/static/logo_kravmaga.png',
                  retina: '/static/logo_kravmaga@2x.png',
                  url: 'http://www.kravmaga-praha.cz/'
                },
                {
                  id: 4,
                  image: '/static/logo-beecom.png',
                  retina: '/static/logo-beecom@2x.png',
                  url: 'https://beecom.io/'
                },
                {
                  id: 5,
                  image: '/static/logo-cash.png',
                  retina: '',
                  url: 'http://www.cashonly.cz/'
                },
                {
                  id: 6,
                  image: '/static/logo-losrentalos.png',
                  retina: '',
                  url: 'http://losrentalos.cz/'
                },
                {
                  id: 7,
                  image: '/static/logo-films.png',
                  retina: '/static/logo-films@2x.png',
                  url: 'http://fluxfilms.cz/'
                },
                {
                  id: 8,
                  image: '/static/logo_bohemian.png',
                  retina: '',
                  url: 'http://bohemianfoodie.cz/'
                },
                {
                  id: 9,
                  image: '/static/logo_hexar.png',
                  retina: '/static/logo_hexar@2x.png',
                  url: 'https://rental.hexar.cz/'
                },
                {
                  id: 10,
                  image: '/static/logo_geek.png',
                  retina: '/static/logo_geek@2x.png',
                  url: 'https://www.geekshirts.cz/'
                }
              ]
            }
        },
        methods: {
            scrollTo (selector) {
                this.drawer = false;
                if (this.$router.currentRoute.name !== 'Index') {
                  this.$router.push('/?scrollTo=' + selector);
                } else {
                  this.$vuetify.goTo('#' + selector, this.options);
                }
            },
          footerClass (index) {
              if (index === this.logos.length - 1) {
                return '';
              }
              switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 'pr-0 pb-5'
                case 'sm': return 'pr-0 pb-5'
                case 'md': return 'pr-4 pb-0'
                case 'lg': return 'pr-5 pb-0'
                case 'xl': return 'pr-5 pb-0'
              }
          }
        }
    }
</script>

<style>
  @font-face {
    font-family: 'bebas_neuethin';
    src: url('./assets/fonts/bebasneue_thin-webfont.woff2') format('woff2'),
    url('./assets/fonts/bebasneue_thin-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'bebas_neueregular';
    src: url('./assets/fonts/bebasneue-webfont.woff2') format('woff2'),
    url('./assets/fonts/bebasneue-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'bebas_neuebold';
    src: url('./assets/fonts/bebasneue_bold-webfont.woff2') format('woff2'),
    url('./assets/fonts/bebasneue_bold-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;

  }

  @font-face {
    font-family: 'bebas_neuebook';
    src: url('./assets/fonts/bebasneue_book-webfont.woff2') format('woff2'),
    url('./assets/fonts/bebasneue_book-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;

  }

  @font-face {
    font-family: 'bebas_neuelight';
    src: url('./assets/fonts/bebasneue_light-webfont.woff2') format('woff2'),
    url('./assets/fonts/bebasneue_light-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;

  }

  @font-face {
    font-family: 'bebas_neueregular';
    src: url('./assets/fonts/bebasneue_regular-webfont.woff2') format('woff2'),
    url('./assets/fonts/bebasneue_regular-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  .thin { font-family: 'bebas_neuethin', Arial, sans-serif !important; }
  .book { font-family: 'bebas_neuebook', Arial, sans-serif !important; }
  .regular { font-family: 'bebas_neueregular', Arial, sans-serif !important; }
  .strong { font-family: 'bebas_neuebold', Arial, sans-serif !important; }
  .light-navy { color: #125190 }
  .primary-text { color: #ed79ac !important;}
  .menu-text { font-size: 18px !important }
  .menu-text-button { font-size: 20px !important; }
  .font-36 { font-size: 36px }
  .font-34 { font-size: 34px }
  .hospital-green { background-color: #a6d7b8 }
  .v-toolbar__content { padding-right: 0 !important; }
  .light-grey { color: rgba(0, 0, 0, 0.54) }
  .no-decoration { text-decoration: none; }
  .mainLink {
    line-height: 1;
  }

  .hero-background { background: url("/static/hero-background.png")}
  .hero-background-retina { background: url("/static/hero-background@2x.png")}
  .hero-note { background: url("/static/hero-sesit.png") no-repeat; height: 567px;}
  .challenge-background { background: url("/static/vyzva-background.png") }
  .font-64 { font-size: 64px }
  .font-24 { font-size: 24px !important;}
  .font-20 { font-size: 20px !important;}
  .font-48 { font-size: 48px }
  .font-16 { font-size: 16px }
  .font-12 .v-label { font-size: 12px !important;}
  .margin-144 { margin-left: 144px;}
  .line-height { line-height: 2; }
  .margin-zero { margin-top: -5px; }
  .hospital-green-text { color: #a6d7b8 !important; }
  .darker-grey { color: rgba(0, 0, 0, 0.87); }
  .max-py { padding-top: 150px !important; padding-bottom: 150px !important; }
</style>



// WEBPACK FOOTER //
// src/App.vue